import { render, staticRenderFns } from "./qTextArea.vue?vue&type=template&id=68726c0a&"
import script from "./qTextArea.vue?vue&type=script&lang=ts&"
export * from "./qTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports